import { render, staticRenderFns } from "./GroupIndex.vue?vue&type=template&id=728e98b8&scoped=true"
import script from "./GroupIndex.vue?vue&type=script&lang=js"
export * from "./GroupIndex.vue?vue&type=script&lang=js"
import style0 from "./GroupIndex.vue?vue&type=style&index=0&id=728e98b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "728e98b8",
  null
  
)

export default component.exports